import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.splice.js";
export var useDisplayMaxFiveItems = function useDisplayMaxFiveItems(props) {
  var observer = null;
  var items = _toConsumableArray(props.items);
  var isItemsShouldBeSplit = computed(function () {
    return items.length > 5;
  });
  var itemsToDisplay = ref([]);
  var itemsToDisplayAfterButtonClick = ref([]);
  var list = ref(null);
  var isExpanded = ref(false);
  var toggleIsCollapsed = function toggleIsCollapsed() {
    return isExpanded.value = !isExpanded.value;
  };
  var observeCompositionListSectionAndFoldIfNecessary = function observeCompositionListSectionAndFoldIfNecessary() {
    itemsToDisplay.value = items.splice(0, 5);
    if (isItemsShouldBeSplit.value) {
      itemsToDisplayAfterButtonClick.value = items;
      var collapseItemsIfOutOfViewport = function collapseItemsIfOutOfViewport(entries) {
        var section = entries[0];
        if (!section.isIntersecting && isExpanded.value) {
          isExpanded.value = false;
        }
      };
      observer = new IntersectionObserver(collapseItemsIfOutOfViewport);
      observer.observe(list.value);
    }
  };
  onMounted(function () {
    observeCompositionListSectionAndFoldIfNecessary();
  });
  onUnmounted(function () {
    if (observer) {
      observer.disconnect();
    }
  });
  return {
    itemsToDisplay: itemsToDisplay,
    itemsToDisplayAfterButtonClick: itemsToDisplayAfterButtonClick,
    isExpanded: isExpanded,
    toggleIsCollapsed: toggleIsCollapsed,
    list: list,
    isItemsShouldBeSplit: isItemsShouldBeSplit,
    observeCompositionListSectionAndFoldIfNecessary: observeCompositionListSectionAndFoldIfNecessary
  };
};